<template>
  <div class="zpa-column no-fit zpa-timeline">
    <div
      class="zpa-row time-item"
      v-for="(t, i) in value"
      :key="i"
    >
      <div class="zpa-row no-fit time">
        <slot name="time" v-bind:row="t">
          {{t.time}}
        </slot>
      </div>

      <div class="zpa-row no-fit line">
        <div class="tag"></div>
      </div>

      <div class="zpa-column content">
        <slot name="content" v-bind:row="t">
          {{t.content}}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zpaTimeline',

  props: {
    value: Array,
  },
}
</script>

<style scoped lang="less">
.zpa-timeline {
  .time-item {
    flex: 1 0 48px;

    .time {
      color: #cfcfcf;
      line-height: 20px;
    }

    &:last-child {
      .line {
        background: transparent;
      }
    }

    .line {
      position: relative;
      flex-basis: 2px;
      margin: 0 24px;
      background: #ccc;

      .tag {
        position: absolute;
        left: -10px;
        top: -1px;
        width: 22px;
        height: 22px;
        border: 2px solid #ccc;
        border-radius: 50%;
        background: #fff;
      }
    }

    .content {
      padding: 0 0 8px 0;
    }
  }
}
</style>
